<div class="w-full h-full flex items-center justify-center text-vinciBlue-600">
  <icon [name]="'loader'" [size]="'5rem'"></icon>
</div>
